<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small" v-if="mqInfoType !== 5">
    <el-row>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.roleId"
          placeholder="用户角色"
        >
          <el-option
            v-for="(item, i) in roleData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.userStatus"
          placeholder="用户状态"
        >
          <el-option
            v-for="(item, i) in userStatusData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.userSex"
          placeholder="性别"
        >
          <el-option
            v-for="(item, i) in sexData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.leaderType"
          placeholder="管理主体"
        >
          <el-option
            v-for="(item, i) in leaderTypeData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.isExam"
          placeholder="考核状态"
        >
          <el-option
            v-for="(item, i) in publicData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.isFinish"
          placeholder="达标状态"
        >
          <el-option
            v-for="(item, i) in publicData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          size="small"
          v-model="filters.name"
          placeholder="请输入用户姓名"
        ></el-input>
      </el-form-item>
      <el-form-item v-show="!showMore" class="m-l-14">
        <butn btntype="primary" title="查询" @click="initData"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
        <butn
          title="展开"
          iconName="el-icon-arrow-down"
          @click="showMore = true"
          class="czButn"
        ></butn>
      </el-form-item>
    </el-row>
    <el-row v-show="showMore">
      <el-form-item label="出生日期：">
        <el-date-picker
          class="date-picker"
          value-format="yyyy-MM-dd"
          size="small"
          v-model="filters.birthTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          unlink-panels
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="用户学分：" class="m-l-14">
        <el-input-number
          class="credit-input"
          v-model="filters.startCredit"
          type="number"
          :min="0"
        /><span class="sepertor">至</span
        ><el-input-number
          class="credit-input"
          v-model="filters.endCredit"
          type="number"
          :min="filters.startCredit"
        />
      </el-form-item>
      <el-form-item class="m-l-14">
        <butn btntype="primary" title="查询" @click="initData"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
        <butn
          title="收起"
          iconName="el-icon-arrow-up"
          @click="showMore = false"
          class="czButn"
        ></butn>
      </el-form-item>
    </el-row>
  </el-form>
  <el-form class="serach-form align_right" :inline="true" :model="filters" size="small" v-else>
    <el-row>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.isCommit"
          placeholder="提交状态"
        >
          <el-option
            v-for="(item, i) in commitData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          size="small"
          v-model="filters.userName"
          placeholder="请输入用户姓名"
        ></el-input>
      </el-form-item>
      <el-form-item class="m-l-14">
        <butn btntype="primary" title="查询" @click="initData"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
      </el-form-item>
    </el-row>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
import { getRoleList } from "@/api/massMessage";
export default {
  components: { butn },
  data() {
    return {
      filters: {},
      roleData: [],
      userStatusData: [],
      sexData: [],
      leaderTypeData: [],
      publicData: [],
      commitData: [],
      showMore: false,
    };
  },
  props: {
    mqInfoType: {
      type: Number,
      default: 0
    }
  },
  created() {
    getRoleList().then((res) => {
      if (!res || res.code != 0) return;
      let arr = res.data.map((ele) => ({
        paramKey: ele.uuid,
        paramValue: ele.roleName,
      }));
      arr.splice(0, 0, {
        paramKey: "",
        paramValue: "全部",
      });
      this.roleData = arr;
    });
    this.getSysParamByTypes([
      "USER_STATUS",
      "USER_SEX",
      "USER_LEADER_TYPE",
      "IS_VALID",
      "IS_COMMIT"
    ]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["USER_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["USER_SEX"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["USER_LEADER_TYPE"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["IS_VALID"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["IS_COMMIT"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.userStatusData = res.data["USER_STATUS"];
        this.sexData = res.data["USER_SEX"];
        this.leaderTypeData = res.data["USER_LEADER_TYPE"];
        this.publicData = res.data["IS_VALID"];
        this.commitData = res.data["IS_COMMIT"];
      });
    },
    initData() {
      if (this.filters.startCredit && this.filters.endCredit) {
        if (
          parseInt(this.filters.startCredit) > parseInt(this.filters.endCredit)
        ) {
          this.$message({
            message: "请输入正确的用户学分区间",
            type: "warning",
          });
          return;
        }
      }
      let params = { ...this.filters };
      delete params.birthTime;
      params.page = 1;
      if (this.filters.birthTime) {
        params["startDate"] = this.filters.birthTime[0];
        params["endDate"] = this.filters.birthTime[1];
      }
      this.$emit("search", params);
    },
    resetData() {
      this.filters = {};
      this.$emit("search", {});
    },
  },
};
</script>

<style lang="scss" scoped>
$color: #d7dbe0;
$border-radius: 2px;
.align_right {
  text-align: right !important;
}
.serach-form {
  text-align: left;
  border-bottom: 1px dashed #ebeef5;
  margin-bottom: 20px;
  & /deep/ .none-margin-right {
    margin-right: 0;
  }
  & /deep/ .date-picker {
    width: 240px;
  }
  /deep/ .credit-input {
    // width: 160px;
    border-radius: 2px;
    // border: 1px solid #dcdfe6;
    height: 30px;
    color: #606266;
    outline: none;
    -webkit-appearance: none;
    background-color: #ffffff;
    background-image: none;
    // padding: 0 10px;
    &:focus {
      border-color: #3a85ff;
    }
  }
  .sepertor {
    margin: 0 10px;
  }
}
</style>
